import { useCallback } from 'react';
import type { TrackingEvent } from '@openclassrooms/sdk-web';
import { useTrackingEventCreate } from '.';

export default function useTracker() {
  const [publishOnAPI] = useTrackingEventCreate();

  const track = useCallback(
    (
      eventName: TrackingEvent['name'],
      { type = 'TRACK', data }: Partial<Pick<TrackingEvent, 'type' | 'data'>> = {}
    ) => {
      const eventToTrack: TrackingEvent = {
        name: eventName,
        type,
        data,
      };

      publishOnAPI(eventToTrack);
    },
    [publishOnAPI]
  );

  return track;
}
